import { AbstractCommand } from "./AbstractCommand"
import type { CommandInterface } from "./CommandInterface"
import { isUpdateStateCommand } from "src/responses"

/**
 * Command to resume a paused print job.
 */
export class ResumeCommand extends AbstractCommand {
	public category: CommandInterface["category"] = "print"
	public command: CommandInterface["command"] = "resume"

	public constructor() {
		super({
			param: "",
		})
	}

	ownsResponse = isUpdateStateCommand
}